import { Controller } from '@hotwired/stimulus';

// Mobile-first PRP /review page.
// Pins a compact CTA bar to the bottom of the viewport whenever the in-flow CTA
// section is off-screen (above OR below it), and hides the bar while that
// section is visible.
export default class extends Controller {
  static targets = ['cta', 'bar'];

  connect() {
    // Resilient: do nothing without an in-flow CTA to watch, a bar to pin, and
    // IntersectionObserver support. The in-flow CTA still works on its own.
    if (!this.hasCtaTarget || !this.hasBarTarget) return;

    this.publishBarHeight();

    // The bar reflows when the price label wraps, so keep the height current.
    if ('ResizeObserver' in window) {
      this.barResizeObserver = new ResizeObserver(() => this.publishBarHeight());
      this.barResizeObserver.observe(this.barTarget);
    }

    if (!('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          this.barTarget.classList.toggle('is-pinned', !entry.isIntersecting);
        }
      },
      { threshold: 0 }
    );
    this.observer.observe(this.ctaTarget);
  }

  // The footer that must clear this bar is a sibling of the hero, so publish the
  // measured height on the root element for the page to read.
  publishBarHeight() {
    // The ResizeObserver can fire after the bar leaves the DOM.
    if (!this.hasBarTarget) return;

    const height = this.barTarget.offsetHeight;
    if (!height) return;

    document.documentElement.style.setProperty('--prp-pinned-cta-height', `${height}px`);
  }

  disconnect() {
    this.observer?.disconnect();
    this.barResizeObserver?.disconnect();
    document.documentElement.style.removeProperty('--prp-pinned-cta-height');
  }
}
